import { css } from '@emotion/react';

import type { Theme } from '@coursera/cds-common';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('ShowMoreContainer', [
  'ctaButton',
  'ctaIcon',
  'standard',
  'silent',
  'content',
]);

const getShowMoreContainerCss = (theme: Theme) => css`
  .${classes.ctaButton} {
    margin-bottom: var(--cds-spacing-150);
    margin-left: -8px; /* aligns chevron to content */
    text-align: left; /* overrides default center-aligned button */
    align-content: flex-start; /* aligns the chevron and label to the top per spec */
    align-items: flex-start;
  }

  .${classes.ctaIcon} {
    flex-shrink: 0;
    color: inherit;
    margin-top: 2px; /* re-align icon after flex-start */
    transform: ${theme.direction === 'rtl' ? 'rotate(180deg)' : 'rotate(0deg)'};
    transition: transform 150ms ease-in-out;

    &.expanded {
      transform: rotate(90deg);
    }
  }

  .${classes.content} {
    overflow: hidden;

    &.${classes.standard} {
      border: 1px solid var(--cds-color-neutral-stroke-primary);
      border-radius: var(--cds-border-radius-50);
      padding: var(--cds-spacing-200);
      background: var(--cds-color-neutral-background-primary);
    }

    &.${classes.silent} {
      background: transparent;
    }
  }
`;

export default getShowMoreContainerCss;
